module.exports = __webpack_public_path__ + "img/40_38_051_510.2ab76619.jpg";